
<div>
    <a class  = "audit-menu" @click ="onClick">
        <div
            v-if="label"
            class  = "fab-button"
        >
            <div
                class  = "fab-icon primary-border"
            >
                <v-icon size="22" color="primary">{{ icon }}</v-icon>
            </div>
            <div class="fab-label">
                {{ label }}
            </div>
        </div>

        <div
            v-if="!label"
            class  = "fab-button v-flex"
        >
            <v-icon size="22" color="primary">{{ icon }}</v-icon>
        </div>
    </a>
</div>
